// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__EfBXz","row":"Footer_row__UOm1A","flexWraper":"Footer_flexWraper__mdjO+","office":"Footer_office__DYyYV"};